
import mapMultiSceneGetActions from './mapmultiscene';

export * from './mapmultiscene';

export function getActions(dispatch) {
    return {
        ...mapMultiSceneGetActions(dispatch)
    }
}
